import React from "react";

import { ClockBlack } from "@routes/IconeSvg";
import { useController } from "react-hook-form";

import DisclosureCollapse from "@components/tailwindComponents/DisclosureCollapse";

import { getDateToRender } from "@helpers/_functions";

import WeeklyHoursSectionItem from "./WeeklyHoursSectionItem";

export const WEEK_DAYS = [
  { _id: 1, key: "monday", label: "Lundi" },
  { _id: 2, key: "tuesday", label: "Mardi" },
  { _id: 3, key: "wednesday", label: "Mercredi" },
  { _id: 4, key: "thursday", label: "Jeudi" },
  { _id: 5, key: "friday", label: "Vendredi" },
  { _id: 6, key: "saturday", label: "Samedi" },
  { _id: 7, key: "sunday", label: "Dimanche" }
];

export function buildDefaultWeeklyHours({
  weeklyHours = {},
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
} = {}) {
  return WEEK_DAYS.reduce((acc, day) => {
    const {
        startDateTime = null,
        endDateTime = null,
        isLunchHourShowed = false,
        lunchStartDate = null,
        lunchEndDate = null
      } = weeklyHours?.[day.key] || {},
      [startDate, endDate, lunchStartDateRender, lunchEndDateRender] = [
        startDateTime,
        endDateTime,
        lunchStartDate,
        lunchEndDate
      ].map((date) => getDateToRender(date, timezone));
    acc[day.key] = {
      startDateTime: startDate,
      endDateTime: endDate,
      startTime: startDate,
      endTime: endDate,
      isLunchHourShowed,
      lunchStartDate: lunchStartDateRender,
      lunchEndDate: lunchEndDateRender,
      dateRange: {
        startDate,
        endDate
      }
    };
    return acc;
  }, {});
}

export default function WeeklyHoursSection({
  control,
  expandedDayKeys = [],
  onExpandedDayChange,
  t = (value) => value,
  formValidation,
  setValue
}) {
  const {
    fieldState: { invalid }
  } = useController({
    name: "weeklyHours",
    control,
    rules: {
      validate: (weeklyHoursValues) =>
        Object.values(weeklyHoursValues || {}).some(({ startTime, endTime }) =>
          Boolean(startTime && endTime)
        )
    }
  });

  return (
    <DisclosureCollapse
      defaultOpen={true}
      invalid={invalid}
      titleClass={invalid ? "!arh-text-invalidColorTextInput" : ""}
      icon={ClockBlack()}
      title={t("Horaires")}
      width="arh-w-full !arh-p-2.5"
      unmount={false}
      noTranslate={true}
      caretSpacingClass="arh-mr-3"
    >
      <div className="arh-max-h-[19rem] arh-overflow-y-auto">
        {WEEK_DAYS.map((day) => (
          <WeeklyHoursSectionItem
            key={day.key}
            day={day}
            control={control}
            expandedDayKeys={expandedDayKeys}
            setValue={setValue}
            onExpandedDayChange={onExpandedDayChange}
            formValidation={formValidation}
          />
        ))}
      </div>
    </DisclosureCollapse>
  );
}
